export default __webpack_public_path__ + "static/media/webBanner.6c533a6d.svg";